module.exports = ".import-data-section {\n  border: 1px solid #d7d7d7;\n  padding: 15px;\n  background: #fdeae4;\n  color: #790000; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/brands/modals/brand-create-modal/brand-create-modal.scss
// module id = ./web/modern/components/brands/modals/brand-create-modal/brand-create-modal.scss
// module chunks = 0